import type { RefObject } from 'react';
import type { AutocompleteApi } from '@algolia/autocomplete-core';
import type { AutocompleteItem } from './Searchbar.types';

export const formatPrice = (price: number) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(price);

export const getAutocompleteProps = (
  autocomplete: AutocompleteApi<
    AutocompleteItem,
    React.BaseSyntheticEvent,
    React.MouseEvent,
    React.KeyboardEvent
  >,
  inputRef: RefObject<HTMLInputElement>,
  autocompleteId: string,
) => {
  return {
    root: autocomplete.getRootProps(),
    form: autocomplete.getFormProps({
      inputElement: inputRef.current,
    }),
    input: autocomplete.getInputProps({
      inputElement: inputRef.current,
      id: autocompleteId,
      // eslint-disable-next-line no-useless-computed-key
      ['aria-labelledby']: null,
    }),
    panel: autocomplete.getPanelProps(),
  };
};
